import {get, post} from '../interceptor'

let displayUrl = '/photovolDisplay';
export default {
  getSensorInfo (params) { return post(displayUrl, '/getSensorInfo', params); },
  getSensorCurve (params) { return post(displayUrl, '/getSensorCurve', params); },
  getBuildInfo (params) { return post(displayUrl, '/getBuildInfo', params); }
}



// WEBPACK FOOTER //
// ./src/api/energy/photovol.js